import moment from "moment";
import "moment/locale/zh-cn";
import getApexDomain from "get-apex-domain";
moment.locale("zh-cn");

// tslint:disable:early-exit
// tslint:disable:no-unnecessary-else
/** 数字分割转换千分位 */
export function comdify(n: string | number) {
  const re = /\d{1,3}(?=(\d{3})+$)/g;
  const n1 = n.toString().replace(/^(\d+)((\.\d+)?)$/, (s, s1: string, s2: string) => { return s1.replace(re, "$&,") + s2; });
  return n1;
}

/** 处理并发服务 */
export function getPublisherUrls(url: string) {
  return ["g00", "g01", "g02", "g03", "g04", "g05", "g06", "g07", "g08", "g09"]
    .map(s => url.replace("api.gagogroup.cn", `${s}.gagogroup.cn`));
}

/**
 * 数字转换为分割千位数
 * @author 马俊峰
 * @date 2019-10-10
 * @export
 * @param {number} num
 * @returns {string}
 */
export function numberToThousands(num: number): string {
  let result = "";
  let counter = 0;
  const dot = String(num).indexOf(".");
  if (dot !== -1) {
    const dotCnt = String(num).substring(dot + 1);
    let numHead = String(num).split(".")[0];
    numHead = (numHead || 0).toString();
    for (let i = numHead.length - 1; i >= 0; i--) {
      counter++;
      result = numHead.charAt(i) + result;
      if (!(counter % 3) && i !== 0) { result = "," + result; }
    }
    result = `${result}.${dotCnt}`;
    return result;
  } else {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
  }
}
 /**
  * 根据数据大小判断展示的长度
  * @author 马俊峰
  * @date 2019-10-11
  * @export
  * @param {number} maxValue
  * @param {number} value
  * @returns {string}
  */
export function judgeDataShowWidth(maxValue: number, value: number): string {
  return `${Number(value / maxValue * 100).toFixed(0)}%`;
}

/**
 * 根据数据返回占用数据的百分比
 * @author 马俊峰
 * @date 2019-10-30
 * @export
 * @param {number} maxValue
 * @param {number} value
 * @returns {number}
 */
export function judgePercentageShare(datalist: number[]): number[] {
  const maxValue = Number(datalist.reduce((total: number, item: number) => total + Number(item), 0).toFixed(0));
  const percentageShare = datalist.map<number>(item => (Number(Number(item / maxValue * 100).toFixed(2))));
  let exceptLast = 0;
  for (let index = 0; index < percentageShare.length; index++) {
    const element = percentageShare[index];
    if (index === percentageShare.length - 1) break;
    exceptLast += element;
  }
  [percentageShare[percentageShare.length - 1]] = [Number((100 - exceptLast).toFixed(2))];
  return percentageShare;
}
/** 判断时间返回当前时间之前 */
export function momentFromNow(time: string | undefined): string {
  if (moment(time).unix() - moment().unix() > 7200) { return "两小时前"; }
  return moment(time).fromNow();
}
interface FormDataType { [key: string]: any; }
/** form-data类型处理 */
export function formDataTypeHandle(data: FormDataType) {
  const formData = new FormData();
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const element = data[key];
      formData.append(key, element);
    }
  }
  return formData;
}
/** 写入cookie */
export function setCookie(cname: string, cvalue: any, exdays?: number) {
  const domain = getApexDomain();
  const date = new Date();
  const time = exdays ? exdays * 24 * 60 * 60 * 1000 : 30 * 60 * 1000;
  date.setTime(date.getTime() + time);
  const expires = "expires=" + date.toUTCString();
  if (domain === undefined) {
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
  } else {
    document.cookie = `${cname}=${cvalue};${expires};domain=${domain};path=/`;
  }
}
/** 取出cookie */
export function getCookie(cname: string) {
  const name = cname + "=";
  const ca = document.cookie.split(";");
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") { c = c.substring(1); }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
/** 删除cookie */
export function deleteCookie(cname: string) {
  const date = new Date();
  date.setTime(date.getTime() - (24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = `${cname}=;${expires};path=/`;
}
